import moment from "moment"
import cloneDeep from 'lodash/cloneDeep'
import { recorrenciaApiParaCadastro } from '../../components/ModalCadastroFinanceiro/cadastroFinanceiroRecorrenciaUtils'
import {
  opcaoClassificacaoFiscal,
  opcaoMultaTipo,
} from '../../components/ModalCadastroFinanceiro/cadastroFinanceiroClassificacaoFiscal'
import { origemEdicaoFromApi } from '../../components/ModalCadastroFinanceiro/cadastroFinanceiroClienteUtils'
import {
  parseValorBr,
  somaPagamentosEmbarque,
  normalizarPagamentosEmbarqueDaApi,
  normalizarCompetenciaPrimeiroDia,
} from '../../components/ModalCadastroFinanceiro/cadastroFinanceiroUtils'

const vencimentoEhAtrasado = (vencimento, hoje = new Date()) => {
  const m = moment(vencimento)
  return m.isValid() && moment(hoje).isAfter(m)
}

const parseDataFormulario = (valor, fallback = null) => {
  if (valor == null || valor === '') {
    return fallback
  }
  const m = moment(valor, 'YYYY-MM-DD', true)
  if (m.isValid()) {
    return m.toDate()
  }
  const flex = moment(valor)
  return flex.isValid() ? flex.toDate() : fallback
}

const linhaPagamentoEmbarqueVazia = () => ({
  valor: "",
  formaPagamento: {
    label: "Selecione a forma de pagamento!",
    value: "",
    pag_credito: null,
    pag_idtipo: null,
  },
  banco: { label: "Selecione o banco!", value: 0 },
  fontePagamento: { label: "Selecione a fonte de pagamento!", value: "" },
  parcela: { label: "1X", value: 1 },
  dataPagamento: new Date(),
  comprovantesArquivos: [],
})

/** Primeiro e último dia do mês corrente + vista padrão (navegação tipo agenda). */
const datasFiltroMesCorrente = () => {
  const a = new Date()
  return {
    filtroDataDe: new Date(a.getFullYear(), a.getMonth(), 1),
    filtroDataAte: new Date(a.getFullYear(), a.getMonth() + 1, 0),
    filtroPeriodoVista: 'mes',
  }
}

const INITIAL_STATE = {
  faturaConta: {},
  faturasContas: { data: [] },
  faturasContasAll: false,
  faturasContasCheckAll: false,
  faturasContasIdsSelecionadas: [],
  faturasContasSelecionadas: [],
  faturasContasReceberCheckAll: false,
  faturasContasReceberIdsSelecionadas: [],
  faturasContasReceberSelecionadas: [],
  cadastro: {
    quantidadeLancamento: 1,
    nome: '',
    descricao: '',
    competencia: new Date(),
    vencimento: new Date(),
    ultimoPagamento: null,
    dataNf: null,
    pagamento: {
      label: '', value: 0
    },
    parcela: null,
    recorrente: false,
    repetir: false,
    tipoFrequenciaRecorrencia: 'MENSAL',
    periodicidade: { value: 'MENSAL', label: 'Todo mês (mensal)' },
    dataDiaVencimentoRecorrencia: null,
    diaVencimentoRecorrencia: { value: 'DATA_VENCIMENTO', label: 'Dia de vencimento' },
    terminoRecorrencia: { value: 'POR_OCORRENCIAS', label: 'Por número de ocorrências' },
    frequencia: { value: 'MENSAL', label: 'Mensalmente' },
    quantidade: 12,
    dataLancamentoRecorrencia: null,
    repetirAnualmente: { value: 'NAO', label: 'Não — repetir todo mês neste dia' },
    diasSemanaRecorrencia: [],
    diasMesRecorrencia: [],
    dataTerminoRecorrencia: null,
    classificacaoFiscal: null,
    multaTipo: opcaoMultaTipo('FIXO'),
    tipoOrigem: 'CLIENTE',
    cliente: null,
    clienteTexto: null,
    origemRazaoSocial: '',
    origemNomeFantasia: '',
    origemEndereco: '',
    origemTexto: '',
    origemCnpj: '',
    valor: 0,
    desconto: 0,
    acrescimo: 0,
    valorPago: 0,
    saldo: 0,
    multa: 0,
    total: 0,
    categoria_id: null,
    pagamentosEmbarque: [linhaPagamentoEmbarqueVazia()],
  },
  dadosFiltro: {
    ...datasFiltroMesCorrente(),
    tipo: '',
    id: "",
    origem: "",
    categoria: "",
    subCategoria: "",
    status: [],
    tipoConta: "",
    segmento: "",
    clear: false
  },
  categoriaCadastrar: {},
  categorias: [],
  subCategoriaCadastrar: {},
  subCategorias: [],
  paginationReceber: null,
  indexAtual: null,
  totalValor: 0,
  totaisPorCategoria: [],
  totaisPendentePago: { total_pendente: 0, total_pago: 0, total_vencido: 0 },
  resumoVencimentos: { por_dia: [], maiores_origens: [] },
  acao: 'cadastro',
  cifrao: 'R$',
  recorrentes: false
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'CONTAS_RECEBER_LIMPAR': {
      return { ...state, faturaConta: {}, cadastro: {} }
    }
    case 'CONTAS_RECEBER_FETCH': {
      const constaReceber = action.payload
      return { ...state, faturasContas: constaReceber }
    }
    case 'CONTAS_RECEBER_TOTAIS_CATEGORIA':
      return {
        ...state,
        totaisPorCategoria: Array.isArray(action.payload) ? action.payload : [],
      }
    case 'CONTAS_RECEBER_TOTAIS_PENDENTE_PAGO': {
      const p = action.payload
      return {
        ...state,
        totaisPendentePago: {
          total_pendente: Number(p?.total_pendente) || 0,
          total_pago: Number(p?.total_pago) || 0,
          total_vencido: Number(p?.total_vencido) || 0,
          qtd_pendente: Number(p?.qtd_pendente) || 0,
          qtd_pago: Number(p?.qtd_pago) || 0,
          qtd_vencido: Number(p?.qtd_vencido) || 0,
        },
      }
    }
    case 'CONTAS_RECEBER_RESUMO_VENCIMENTOS': {
      const r = action.payload
      return {
        ...state,
        resumoVencimentos: {
          por_dia: Array.isArray(r?.por_dia) ? r.por_dia : [],
          maiores_origens: Array.isArray(r?.maiores_origens) ? r.maiores_origens : [],
        },
      }
    }
    case 'CONTA_RECEBER_ACAO':
      return { ...state, acao: action.payload }
    case 'CONTA_RECEBER_EDITAR_FETCH': {
      if (!action.payload || typeof action.payload !== 'object') {
        return state
      }

      let cadastroCopy = { ...state.cadastro }

      let copyCifrao = state.cifrao

      const multaTipoOpt = opcaoMultaTipo(action.payload.multa_tipo)

      if (multaTipoOpt.value === 'FIXO') {
        copyCifrao = 'R$'
      } else {
        copyCifrao = '%'
      }

      cadastroCopy = {
        nome: action.payload.nome_conta,
        quantidadeLancamento:
          action.payload.quantidade_lancamento != null
            ? Number(action.payload.quantidade_lancamento)
            : 1,
        categoria: { value: action.payload?.id_categoria, label: action.payload?.nome_categoria },
        categoria_id:
          action.payload?.id_categoria != null && action.payload?.id_categoria !== ""
            ? Number(action.payload.id_categoria)
            : null,
        valor: action.payload.valor_conta,
        descricao: action.payload.descricao,
        titulo: action.payload.titulo,
        ...origemEdicaoFromApi(action.payload),
        // pagamento: { value: action.payload?.pagamento?.pag_id, label: action.payload?.pagamento?.pag_nome },
        documento: action.payload.documento,
        competencia: normalizarCompetenciaPrimeiroDia(
          parseDataFormulario(
            action.payload.data_competencia ?? action.payload.competencia,
            state.cadastro?.competencia ?? new Date()
          )
        ),
        parcela: action.payload?.parcela
          ? { value: action.payload.parcela.par_id, label: action.payload.parcela.par_nome }
          : state.cadastro?.parcela ?? null,
        boleto: action.payload.boleto,
        ultimoPagamento: parseDataFormulario(action.payload.data_ultimo_pagamento, null),
        vencimento: parseDataFormulario(
          action.payload.data_vencimento,
          state.cadastro?.vencimento ?? new Date()
        ),
        valorPago: action.payload.valor_pago,
        saldo: action.payload.saldo,
        desconto:
          action.payload.desconto != null && action.payload.desconto !== ''
            ? action.payload.desconto
            : 0,
        acrescimo:
          action.payload.acrescimo != null && action.payload.acrescimo !== ''
            ? action.payload.acrescimo
            : 0,
        multa: action.payload.multa ?? 0,
        multaTipo: multaTipoOpt,
        classificacaoFiscal: opcaoClassificacaoFiscal(action.payload.classificacao_fiscal),
        juros: action.payload.juros,
        numeroNf: action.payload.numero_nf,
        dataNf: parseDataFormulario(action.payload.data_nf, null),
        id: action.payload.id,
        conta_id: action.payload.conta_id,
        status:
          action.payload.status_calculado ??
          action.payload.status ??
          'PENDENTE',
        data_vencimento_original:
          action.payload.data_vencimento_original ?? action.payload.data_vencimento,
        projecao: !!action.payload.projecao,
        somentePagamentos: !!action.payload.somente_pagamentos,
        acertoId: action.payload.acerto_id ?? null,
        ...recorrenciaApiParaCadastro(action.payload.recorrencia),
      }


      let saldo = 0
      let multa = 0
      const hoje = new Date()
      let tipo = null
      let juros = null

      saldo = Number(cadastroCopy.saldo)
      juros = Number(cadastroCopy.juros)
      multa = Number(cadastroCopy.multa)
      tipo = cadastroCopy.multaTipo?.value

      let totalCalc = saldo;


      const vencimentoMoment = moment(cadastroCopy.vencimento)
      if (vencimentoMoment.isValid() && moment(hoje).isAfter(vencimentoMoment) && tipo !== undefined) {
        if (tipo == 'FIXO' && tipo) {
          totalCalc = saldo + multa
        } else if (tipo == 'PORCENTAGEM' && multa > 0 && tipo) {
          totalCalc = saldo + ((saldo * multa) / 100)
        }
      } else {
        totalCalc = saldo
      }

      cadastroCopy.total = totalCalc.toFixed(2)
      cadastroCopy.pagamentosEmbarque = normalizarPagamentosEmbarqueDaApi(
        action.payload.pagamentosEmbarque,
        linhaPagamentoEmbarqueVazia
      )

      return {
        ...state,
        faturaConta: action.payload,
        cadastro: cadastroCopy,
        cifrao: copyCifrao
      }
    }
    case 'CONTA_RECEBER_FETCH':
      return { ...state, faturaConta: action.payload }
    case 'CONTAS_RECEBER_PAGINATION':
      return { ...state, paginationReceber: action.payload }

    case 'CONTAS_RECEBER_DESCONTO': {
      const copy = { ...state.cadastro };
      const hoje = new Date();

      const somaPagamentos = somaPagamentosEmbarque(copy.pagamentosEmbarque)
      let valorNum = parseValorBr(copy.valor)
      const descontoNum = parseValorBr(copy.desconto)
      const acrescimoNum = parseValorBr(copy.acrescimo)
      const valorPagoNum =
        (copy.pagamentosEmbarque || []).length > 0
          ? somaPagamentos
          : parseValorBr(copy.valorPago)

      if (valorNum <= 0 && somaPagamentos > 0) {
        valorNum = somaPagamentos
      }

      const jurosNum = parseValorBr(copy.juros);
      const multaNum = parseValorBr(copy.multa);

      copy.saldo = valorNum - descontoNum + acrescimoNum - valorPagoNum;

      // 3) calcula total inicial (sem juros)
      let total = copy.saldo;
      const tipo = copy.multaTipo?.value;

      const vencM = moment(copy.vencimento)
      if (vencimentoEhAtrasado(copy.vencimento, hoje)) {
        if (tipo === "FIXO") {
          total = copy.saldo + multaNum;
        } else if (tipo === "PORCENTAGEM" && multaNum > 0) {
          total = copy.saldo + (copy.saldo * multaNum) / 100;
        }
      }

      // 4) aplica juros de atraso, se houver
      const dataChecada = moment(hoje).add(1, "days");
      const mesesAtraso = vencM.isValid()
        ? moment(dataChecada).diff(vencM, "months", true)
        : 0;
      if (jurosNum > 0 && vencM.isValid() && moment(dataChecada).isAfter(vencM)) {
        const juroMes = jurosNum * Math.floor(mesesAtraso);
        total = total + (total * juroMes) / 100;
      }

      // 5) formata com duas casas decimais
      copy.total = total.toFixed(2);

      return { ...state, cadastro: copy };
    }
    case 'CONTAS_RECEBER_MUDAR_TIPO': {
      const copyContas = { ...state.cadastro }
      let copyCifrao = { ...state.cifrao }

      if (copyContas.multaTipo?.value == 'FIXO') {
        copyCifrao = 'R$'
      } else {
        copyCifrao = '%'
      }

      return { ...state, cifrao: copyCifrao }
    }
    case 'CONTAS_RECEBER_CALCULAR_TOTAL': {
      const copy = { ...state.cadastro };
      const hoje = new Date();


      const saldoNum = Number(copy.saldo);
      const multaNum = Number(copy.multa);
      const tipo = copy.multaTipo?.value;


      let total = saldoNum;

      if (vencimentoEhAtrasado(copy.vencimento, hoje)) {
        if (tipo === "FIXO") {
          total = saldoNum + multaNum;
        } else if (tipo === "PORCENTAGEM" && multaNum > 0) {
          total = saldoNum + (saldoNum * multaNum) / 100;
        }
      }

      copy.total = total.toFixed(2);


      return { ...state, cadastro: copy };
    }

    case "CONTAS_RECEBER_INPUT_CHANGE": {
      const cadastroCopy = { ...state.cadastro };

      if (
        action.campo == "valor" ||
        action.campo == "desconto" ||
        action.campo == "acrescimo" ||
        action.campo == "valorPago" ||
        action.campo == "saldo" ||
        action.campo == "multa" ||
        action.campo == "juros"
      ) {
        cadastroCopy[action.campo] = parseValorBr(action.payload);
      } else {
        cadastroCopy[action.campo] = action.payload;
      }

      if (action.campo === "categoria") {
        const v = action.payload?.value;
        cadastroCopy.categoria_id =
          v != null && v !== "" ? Number(v) : null;
      }

      return { ...state, cadastro: cadastroCopy };
    }

    case "CONTAS_RECEBER_PAGAMENTO_EMBARQUE_ADD": {
      const cadastroCopy = { ...state.cadastro };
      const arr = [...(cadastroCopy.pagamentosEmbarque || [])];
      arr.push(linhaPagamentoEmbarqueVazia());
      cadastroCopy.pagamentosEmbarque = arr;
      return { ...state, cadastro: cadastroCopy };
    }

    case "CONTAS_RECEBER_PAGAMENTO_EMBARQUE_REMOVE": {
      const cadastroCopy = { ...state.cadastro };
      const arr = [...(cadastroCopy.pagamentosEmbarque || [])];
      if (arr.length <= 1) return state;
      arr.splice(action.index, 1);
      cadastroCopy.pagamentosEmbarque = arr;
      return { ...state, cadastro: cadastroCopy };
    }

    case "CONTAS_RECEBER_PAGAMENTO_EMBARQUE_CHANGE_FORMA": {
      const cadastroCopy = { ...state.cadastro };
      const arr = [...(cadastroCopy.pagamentosEmbarque || [])];
      if (arr[action.index] == null) return state;
      arr[action.index] = { ...arr[action.index], formaPagamento: action.payload };
      cadastroCopy.pagamentosEmbarque = arr;
      return { ...state, cadastro: cadastroCopy };
    }

    case "CONTAS_RECEBER_PAGAMENTO_EMBARQUE_CHANGE_VALOR": {
      const cadastroCopy = { ...state.cadastro };
      const arr = [...(cadastroCopy.pagamentosEmbarque || [])];
      if (arr[action.index] == null) return state;
      arr[action.index] = { ...arr[action.index], valor: action.payload };
      cadastroCopy.pagamentosEmbarque = arr;
      return { ...state, cadastro: cadastroCopy };
    }

    case "CONTAS_RECEBER_PAGAMENTO_EMBARQUE_CHANGE_CAMPO": {
      const cadastroCopy = { ...state.cadastro };
      const arr = [...(cadastroCopy.pagamentosEmbarque || [])];
      if (arr[action.index] == null) return state;
      arr[action.index] = { ...arr[action.index], [action.campo]: action.payload };
      cadastroCopy.pagamentosEmbarque = arr;
      return { ...state, cadastro: cadastroCopy };
    }

    case "CONTAS_RECEBER_PAGAMENTO_EMBARQUE_CHANGE_PARCELA": {
      const cadastroCopy = { ...state.cadastro };
      const arr = [...(cadastroCopy.pagamentosEmbarque || [])];
      if (arr[action.index] == null) return state;
      arr[action.index] = { ...arr[action.index], parcela: action.payload };
      cadastroCopy.pagamentosEmbarque = arr;
      return { ...state, cadastro: cadastroCopy };
    }

    case "CONTAS_RECEBER_PAGAMENTO_EMBARQUE_CHANGE_BANCO": {
      const cadastroCopy = { ...state.cadastro };
      const arr = [...(cadastroCopy.pagamentosEmbarque || [])];
      if (arr[action.index] == null) return state;
      arr[action.index] = { ...arr[action.index], banco: action.payload };
      cadastroCopy.pagamentosEmbarque = arr;
      return { ...state, cadastro: cadastroCopy };
    }

    case 'CONTAS_RECEBER_CHECK_ALL': {
      return { ...state, faturasContasAll: !state.faturasContasAll }
    }

    case 'CONTAS_FATURAS_CHECK': {

      const copyContas = [...state.faturasContas]
      const ContasCopy = { ...copyContas[action.index] }
      ContasCopy.selecionado = action.value

      copyContas[action.index] = ContasCopy

      return { ...state, faturasContas: copyContas }
    }

    case 'CONTAS_RECEBER_CHECK': {

      const copyContas = [...state.faturasContas]
      const contaCopy = { ...copyContas[action.index] }
      const reservaCopy = { ...contaCopy.lancamentos_financeiros[action.indexConta] }
      reservaCopy.selecionado = action.value

      contaCopy.lancamentos_financeiros[action.index] = reservaCopy
      copyContas[action.index] = contaCopy

      return { ...state, faturasContas: copyContas }
    }

    case 'CONTAS_ABRIR_GRUPO': {
      const faturasContas = [...state.faturasContas]
      const index = action.index
      const atualIndex = action.indexAtual
      const teste = { ...faturasContas[index] }

      if ((atualIndex) && (index != atualIndex)) {
        const faturaAtual = { ...faturasContas[atualIndex] }
        faturaAtual.grupoAberto = false
        faturasContas[atualIndex] = faturaAtual
      } else if ((atualIndex) || index >= 0) {
        const faturaAtual = { ...faturasContas[atualIndex] }
        faturaAtual.grupoAberto = false
        faturasContas[atualIndex] = faturaAtual

      }

      teste.grupoAberto = !teste.grupoAberto
      faturasContas[index] = teste
      return { ...state, faturasContas, indexAtual: index }
    }

    case 'SELECIONAR_CONTAS_RECEBER': {
      const novasContasIdsSelecionadas = [...state.faturasContasIdsSelecionadas]
      const novasContasSelecionadas = [...state.faturasContasSelecionadas]
      const indexSelect = novasContasIdsSelecionadas.indexOf(action.payload) // Verifica se o número já existe no array
      const indexFaturaSelect = novasContasIdsSelecionadas.indexOf(action.faturaConta) // Verifica se o número já existe no array

      if (indexSelect === -1) {
        // Se não existir, adiciona o número ao array                           
        novasContasIdsSelecionadas.push(action.payload)
        novasContasSelecionadas.push(action.faturaConta)
      } else {
        // Se existir, remove o número do array
        novasContasIdsSelecionadas.splice(indexSelect, 1)
        novasContasSelecionadas.splice(indexFaturaSelect, 1)
      }

      // console.log("novasContasSelecionadas: ", novasContasSelecionadas)
      return { ...state, faturasContasSelecionadas: novasContasSelecionadas, faturasContasIdsSelecionadas: novasContasIdsSelecionadas }

    }

    case 'SELECIONAR_FATURAS_RESERVA': {
      const novasFaturasIdsSelecionadas = [...state.faturasContasReceberIdsSelecionadas]
      const novasFaturasSelecionadas = [...state.faturasContasReceberSelecionadas]
      const indexSelect = novasFaturasIdsSelecionadas.indexOf(action.payload) // Verifica se o número já existe no array
      const indexFaturaSelect = novasFaturasIdsSelecionadas.indexOf(action.faturaFornecedor) // Verifica se o número já existe no array

      if (indexSelect === -1) {
        // Se não existir, adiciona o número ao array                           
        novasFaturasIdsSelecionadas.push(action.payload)
        novasFaturasSelecionadas.push(action.faturaFornecedor)
      } else {
        // Se existir, remove o número do array
        novasFaturasIdsSelecionadas.splice(indexSelect, 1)
        novasFaturasSelecionadas.splice(indexFaturaSelect, 1)
      }

      // console.log("novasFaturasSelecionadas: ", novasFaturasSelecionadas)
      return { ...state, faturasContasReceberSelecionadas: novasFaturasSelecionadas, faturasContasReceberIdsSelecionadas: novasFaturasIdsSelecionadas }

    }

    case 'CONTAS_RECEBER_CATEGORIA_ABRIR_GRUPO': {
      const categorias = [...state.categorias]
      const index = action.index
      const atualIndex = action.indexAtual
      const teste = { ...categorias[index] }

      if ((atualIndex) && (index != atualIndex)) {
        const categoriaAtual = { ...categorias[atualIndex] }
        categoriaAtual.grupoAberto = false
        categorias[atualIndex] = categoriaAtual
      } else if ((atualIndex) || index >= 0) {
        const categoriaAtual = { ...categorias[atualIndex] }
        categoriaAtual.grupoAberto = false
        categorias[atualIndex] = categoriaAtual

      }

      teste.grupoAberto = !teste.grupoAberto
      categorias[index] = teste
      return { ...state, categorias, indexAtual: index }
    }

    case 'CONTAS_RECEBER_CATEGORIA_FETCH': {
      return { ...state, categorias: action.payload }

    }
    case 'CONTAS_RECEBER_CATEGORIA_INPUT_CHANGE': {
      let categgoriaCopy = { ...state.categoriaCadastrar }

      if (action.campo == 'limpar') {
        categgoriaCopy = {}
      } else {
        categgoriaCopy[action.campo] = action.payload
      }
      return { ...state, categoriaCadastrar: categgoriaCopy }
    }

    case 'CONTAS_RECEBER_SUBCATEGORIA_FETCH': {
      return { ...state, subCategorias: action.payload }
    }

    case 'CONTAS_RECEBER_SUBCATEGORIA_INPUT_CHANGE': {
      let categgoriaCopy = { ...state.subCategoriaCadastrar }

      if (action.campo == 'limpar') {
        categgoriaCopy = {}
      } else {
        categgoriaCopy[action.campo] = action.payload
      }
      return { ...state, subCategoriaCadastrar: categgoriaCopy }
    }

    case 'CONTAS_RECEBER_SET_FILTRO': {
      const dadosFiltroCopy = { ...state.dadosFiltro }
      dadosFiltroCopy[action.campo] = action.valor
      return { ...state, dadosFiltro: dadosFiltroCopy }
    }
    case 'CONTAS_RECEBER_SET_FILTRO_CLEAR': {
      const dadosFiltroCopy = {
        ...datasFiltroMesCorrente(),
        tipo: '',
        id: '',
        origem: '',
        nome: '',
        categoria: '',
        subCategoria: '',
        status: [],
        tipoConta: '',
        segmento: '',
        clear: false,
      }
      return { ...state, dadosFiltro: dadosFiltroCopy }
    }

    case 'CONTA_RECEBER_LIMPAR_INPUTS': {
      return {
        ...state,
        cadastro: cloneDeep(INITIAL_STATE.cadastro),
        // categorias: [],
        // subCategorias: [],

      };
    }

    default:
      return state
  }
}